// test772
(772 && 0);
